import React from 'react';

export default function Pipe(props) {

        const upperPipeHeight = props.upperPipeHeight;
        const pipeX = props.x;

        const lowerHeight = props.bottomPipeTop;
        const bottomPipeHeight = props.bottomPipeHeight;
        
        const color = props.isHit ? 'black' : '#C05939';

        return (
            <div id="pipe" >
            </div>
        );
    }